import moment from 'moment';
import { HTTP, authHeader } from './http-service';

class BackOfficeUserService {
  list() {
    return HTTP.get(`/backofficeuser`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  listDisputeUsers() {
    return HTTP.get(`/backofficeuser/dispute`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  getEvents(accountId) {
    return HTTP.post(`/backofficeuser/events`, { accountId }, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  get(payload) {
    return HTTP.post(`/backofficeuser`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  update(payload) {
    return HTTP.put(`/backofficeuser`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  reset(payload) {
    return HTTP.put(`/backofficeuser/reset`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  updateScheme(payload) {
    return HTTP.put(`/backofficeuser/scheme`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  invite(payload) {
    return HTTP.post(`/backofficeuser/invite`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  disable(payload) {
    return HTTP.put(`/backofficeuser/disable`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  archive(payload) {
    return HTTP.put(`/backofficeuser/archive`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  enable(payload) {
    return HTTP.put(`/backofficeuser/enable`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  exportPermissionsCsv() {
    return HTTP.get(`/backofficeuser/permissions/csv`, {
      headers: authHeader(),
      responseType: 'blob',
    }).then((response) => {
      const blob = new Blob([response.data], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `${moment().format('DD.MM.YYYY')} BackOffice Users Permissions.csv`;
      link.click();
      URL.revokeObjectURL(link.href);
      return Promise.resolve(response);
    });
  }

  exportRoleGroupsPermissionsCsv() {
    return HTTP.get(`/backofficeuser/role-groups-permissions/csv`, {
      headers: authHeader(),
      responseType: 'blob',
    }).then((response) => {
      const blob = new Blob([response.data], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `${moment().format('DD.MM.YYYY')} BackOffice Users Permissions.csv`;
      link.click();
      URL.revokeObjectURL(link.href);
      return Promise.resolve(response);
    });
  }
}

export default new BackOfficeUserService();
